import React from 'react';


function ExpPoolEditable({ label, amount, color, onChange }) {
  function adjust(delta) {
    const newVal = Math.max(0, Math.min(999, amount + delta));
    onChange(newVal);
  }

  function handleInput(e) {
    const val = parseInt(e.target.value) || 0;
    onChange(Math.max(0, Math.min(999, val)));
  }

  return (
    <div style={{ background: "rgba(20,16,10,0.5)", border: `1px solid ${color}33`, borderRadius: 8, padding: "10px 12px" }}>
      <div style={{ fontSize: "9px", color: "#6b6048", letterSpacing: 1, textTransform: "uppercase", marginBottom: 6, textAlign: "center" }}>{label}</div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
        <button onClick={() => adjust(-1)} style={{ background: "none", border: `1px solid ${color}44`, color, width: 24, height: 24, borderRadius: 4, cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
        <input
          type="number"
          value={amount}
          onChange={handleInput}
          min="0"
          max="999"
          style={{
            width: 60,
            textAlign: "center",
            fontFamily: "'Cinzel', serif",
            fontSize: "18px",
            color,
            fontWeight: 600,
            background: "rgba(0,0,0,0.3)",
            border: `1px solid ${color}22`,
            borderRadius: 4,
            padding: "4px"
          }}
        />
        <button onClick={() => adjust(1)} style={{ background: "none", border: `1px solid ${color}44`, color, width: 24, height: 24, borderRadius: 4, cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
      </div>
    </div>
  );
}
export default ExpPoolEditable
